/* ============================================================
   KEPT — product page behaviour
   Variant selection, gallery, offer tiles, the accessory add-on,
   quantity, the mobile sticky bar and the campaign countdown.

   Prices are never formatted here. Every variant's price arrives
   pre-rendered by Liquid through the money filter, so currency
   formatting stays correct in every market without this file
   knowing anything about money formats.

   The picker and the gallery are two views of one choice, so
   they drive each other: choosing a colour moves the picture,
   and clicking a picture that belongs to a colour selects it.
   ============================================================ */
(function () {
  'use strict';
  if (window.__keptPdpInit) return;
  window.__keptPdpInit = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

  function initCountdown() {
    var wrap = document.querySelector('[data-kept-urgency][data-end]');
    if (!wrap) return;
    var box = wrap.querySelector('[data-kept-countdown]');
    var out = wrap.querySelector('[data-kept-countdown-value]');
    if (!box || !out) return;

    var end = Date.parse(wrap.getAttribute('data-end'));
    if (isNaN(end)) return;

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      var left = end - Date.now();

      /* A finished campaign hides the whole module rather than restarting it.
         A timer that resets on every visit is not a deadline. */
      if (left <= 0) {
        wrap.hidden = true;
        clearInterval(timer);
        return;
      }

      var days = Math.floor(left / 86400000);
      var hrs = Math.floor(left / 3600000) % 24;
      var mins = Math.floor(left / 60000) % 60;
      var secs = Math.floor(left / 1000) % 60;

      out.textContent = days > 0
        ? days + 'd ' + pad(hrs) + ':' + pad(mins) + ':' + pad(secs)
        : pad(hrs) + ':' + pad(mins) + ':' + pad(secs);
      box.hidden = false;
    }

    tick();
    var timer = setInterval(tick, 1000);
  }

  function init() {
    initCountdown();

    var root = document.querySelector('[data-kept-pdp]');
    if (!root) return;

    var dataEl = root.querySelector('[data-kept-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

    var form       = document.getElementById('kept-pdp-form');
    var idInput    = root.querySelector('[data-kept-variant-id]');
    var priceNow   = root.querySelector('[data-kept-price-now]');
    var priceWas   = root.querySelector('[data-kept-price-was]');
    var submit     = root.querySelector('[data-kept-submit]');
    var submitText = root.querySelector('[data-kept-submit-text]');
    var stage      = root.querySelector('[data-kept-stage]');
    var groups     = [].slice.call(root.querySelectorAll('[data-kept-option-index]'));
    var offer      = root.querySelector('[data-kept-offer]');
    var second     = root.querySelector('[data-kept-second]');
    var addon      = root.querySelector('[data-kept-addon]');
    var qtyInput   = root.querySelector('[data-kept-qty-input]');
    var stickyBar  = document.querySelector('[data-kept-sticky]');
    var stickyPrice= document.querySelector('[data-kept-sticky-price]');

    var addText   = submit ? submit.getAttribute('data-add-text') : '';
    var soldText  = submit ? submit.getAttribute('data-sold-text') : '';
    var busyText  = submit ? submit.getAttribute('data-busy-text') : '';
    var errorText = submit ? submit.getAttribute('data-error-text') : '';

    /* How many cameras the buyer is committing to: 1, or the Duo's 2. */
    var tier = 1;

    /* The Duo's second colour. Liquid pre-selects one the buyer has not
       already chosen, so this reads that choice rather than assuming. */
    var secondValue = null;
    if (second) {
      var preset = second.querySelector('[data-kept-second-value][aria-pressed="true"]');
      if (preset) secondValue = preset.getAttribute('data-kept-second-value');
    }

    /* ---------- gallery ---------- */
    function showMedia(mediaId) {
      if (!stage || !mediaId) return;
      var target = stage.querySelector('[data-media-id="' + mediaId + '"]');
      if (!target) return;
      [].forEach.call(stage.querySelectorAll('img'), function (img) {
        img.classList.toggle('is-active', img === target);
      });
      [].forEach.call(root.querySelectorAll('[data-kept-thumb]'), function (btn) {
        btn.setAttribute('aria-selected', btn.getAttribute('data-kept-thumb') === String(mediaId) ? 'true' : 'false');
      });
    }

    function variantForMedia(mediaId) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].media_id && String(variants[i].media_id) === String(mediaId)) return variants[i];
      }
      return null;
    }

    /* ---------- variants ---------- */
    function selectedOptions() {
      return groups.map(function (group) {
        var pressed = group.querySelector('[aria-pressed="true"]');
        return pressed ? pressed.getAttribute('data-kept-option-value') : null;
      });
    }

    /* Writes a set of option values back into the picker, so a choice made
       anywhere on the page is reflected in the swatch row. */
    function setOptions(opts) {
      if (!opts) return;
      groups.forEach(function (group, i) {
        if (opts[i] === undefined) return;
        [].forEach.call(group.querySelectorAll('[data-kept-option-value]'), function (b) {
          b.setAttribute('aria-pressed', b.getAttribute('data-kept-option-value') === opts[i] ? 'true' : 'false');
        });
        var current = group.querySelector('[data-kept-option-current]');
        if (current) current.textContent = opts[i];
      });
    }

    function matchVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] !== null && v.options[j] !== opts[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function currentVariant() {
      return matchVariant(selectedOptions());
    }

    function apply(variant) {
      if (!variant) {
        if (submit) {
          submit.setAttribute('disabled', 'disabled');
          if (submitText) submitText.textContent = soldText;
        }
        return;
      }
      if (idInput) idInput.value = variant.id;

      /* The headline price answers the question the tiles just asked, so it
         follows the tier rather than always quoting one camera. */
      var now = tier === 2 ? variant.duo : variant.price;
      var was = tier === 2 ? variant.duo_compare : variant.compare_at;

      if (priceNow) priceNow.innerHTML = now;
      if (stickyPrice) stickyPrice.innerHTML = now;
      if (priceWas) {
        if (was) {
          priceWas.innerHTML = was;
          priceWas.hidden = false;
        } else {
          priceWas.hidden = true;
        }
      }

      if (submit) {
        if (variant.available) {
          submit.removeAttribute('disabled');
          if (submitText) submitText.textContent = addText;
        } else {
          submit.setAttribute('disabled', 'disabled');
          if (submitText) submitText.textContent = soldText;
        }
      }
      if (variant.media_id) showMedia(variant.media_id);

      /* Keep the address bar in step so a shared link opens on the same colour. */
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    [].forEach.call(root.querySelectorAll('[data-kept-thumb]'), function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-kept-thumb');
        showMedia(id);

        /* If this picture belongs to a colour, picking it picks the colour.
           A gallery that shows pink while the picker still says black is two
           answers to the same question. */
        var match = variantForMedia(id);
        if (match) {
          setOptions(match.options);
          apply(match);
        }
      });
    });

    groups.forEach(function (group) {
      group.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-kept-option-value]');
        if (!btn || btn.hasAttribute('disabled')) return;
        [].forEach.call(group.querySelectorAll('[data-kept-option-value]'), function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        var current = group.querySelector('[data-kept-option-current]');
        if (current) current.textContent = btn.getAttribute('data-kept-option-value');
        apply(currentVariant());
      });
    });

    /* ---------- offer tiles ---------- */
    if (offer) {
      offer.addEventListener('click', function (event) {
        var tile = event.target.closest('[data-kept-tier]');
        if (!tile) return;
        tier = parseInt(tile.getAttribute('data-kept-tier'), 10) || 1;
        [].forEach.call(offer.querySelectorAll('[data-kept-tier]'), function (t) {
          var on = t === tile;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (second) second.hidden = tier !== 2;
        apply(currentVariant());
      });
    }

    if (second) {
      second.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-kept-second-value]');
        if (!btn) return;
        secondValue = btn.getAttribute('data-kept-second-value');
        [].forEach.call(second.querySelectorAll('[data-kept-second-value]'), function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        var current = second.querySelector('[data-kept-second-current]');
        if (current) current.textContent = secondValue;
      });
    }

    /* ---------- add to cart ---------- */
    /* A plain product form posts exactly one variant. A Duo is two, and the
       adapter is a third, so anything beyond a single line goes through the
       cart API instead. When there is only one line the native post is left
       alone — fewer moving parts on the most common path. */
    if (form) {
      form.addEventListener('submit', function (event) {
        var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
        var primary = idInput ? parseInt(idInput.value, 10) : 0;
        if (!primary) return;

        var items = [];
        function push(id, count) {
          if (!id) return;
          for (var i = 0; i < items.length; i++) {
            if (items[i].id === id) { items[i].quantity += count; return; }
          }
          items.push({ id: id, quantity: count });
        }

        push(primary, qty);

        if (tier === 2) {
          var pair = secondValue ? matchVariant([secondValue]) : null;
          push(pair ? pair.id : primary, qty);
        }

        if (addon && addon.checked) {
          push(parseInt(addon.getAttribute('data-variant-id'), 10), qty);
        }

        var single = items.length === 1 && items[0].quantity === qty;
        if (single) return;

        event.preventDefault();

        if (submit) {
          submit.setAttribute('disabled', 'disabled');
          if (submitText && busyText) submitText.textContent = busyText;
        }

        fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('add failed');
            window.location.href = ROOT + 'cart';
          })
          .catch(function () {
            if (!submit) return;
            submit.removeAttribute('disabled');
            if (submitText && errorText) {
              submitText.textContent = errorText;
              setTimeout(function () { submitText.textContent = addText; }, 3000);
            }
          });
      });
    }

    /* ---------- quantity ---------- */
    [].forEach.call(root.querySelectorAll('[data-kept-qty]'), function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var next = (parseInt(qtyInput.value, 10) || 1) + parseInt(btn.getAttribute('data-kept-qty'), 10);
        qtyInput.value = next < 1 ? 1 : next;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    if (qtyInput) {
      qtyInput.addEventListener('blur', function () {
        var n = parseInt(qtyInput.value, 10);
        qtyInput.value = (!n || n < 1) ? 1 : n;
      });
    }

    /* ---------- mobile sticky bar ---------- */
    /* Revealed only once the real Add to Cart has scrolled out of view, so the
       two buttons are never on screen competing with each other. */
    if (stickyBar && submit && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      observer.observe(submit);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
